import { render, staticRenderFns } from "./questionTypeConfirmation.vue?vue&type=template&id=15e11c57&scoped=true&"
import script from "./questionTypeConfirmation.vue?vue&type=script&lang=js&"
export * from "./questionTypeConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./questionTypeConfirmation.vue?vue&type=style&index=0&id=15e11c57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e11c57",
  null
  
)

export default component.exports